export const secondsToTime = (seconds: number) => {
  const date = new Date(0);
  date.setSeconds(seconds);

  if (seconds >= 3600) {
    // Format of 00:00:00
    return date.toISOString().substring(11, 19).replace(/^0/, '');
  }

  // Format of 00:00
  return date.toISOString().substring(14, 19).replace(/^0/, '');
};
